import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const ShippingMethod = () => {
  return(
    <SettingsMetaData propertyName={"ShippingMethod"} viewPropertyName={"Shipping Method"}/>
  )
};

export default ShippingMethod;
